/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/rules-of-hooks */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import useQuery from '../hooks/useQuery';
import themes from './themes';
import { isThemingEnabled } from './operators/isThemingEnabled';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

const getTheme = () => {
  const stateTheme = useSelector(state => state.theming.theme);
  const queryTheme = useQuery().theme;
  const theme = queryTheme || stateTheme;
  return isThemingEnabled() ? themes[theme] : themes['defaultTheme'];
};

export const ThemeProvider = ({
  children
}) => {
  const theme = getTheme();
  return /*#__PURE__*/_jsx(StyledThemeProvider, {
    theme: theme,
    children: children
  });
};